<template>
  <div class="log-reader" v-if="session" id="logReader">
    <p v-for="(use, index) in session.uses" :key="index">
      <span
        :id="logEventId(use)"
        @mouseover="onEventMouseOver(use)"
        @mouseleave="onEventMouseLeave"
        >{{ generateReadableEvent(use) }}</span
      >
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

//Scroll to
Vue.use(VueScrollTo, {
  el: '#logReader',
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

export default {
  name: 'LogReader',
  props: {
    session: Object,
    selectedLogEvent: Object,
  },
  mounted() {},
  watch: {
    selectedLogEvent: {
      handler() {
        this.scrollToLogEvent()
      },
      immediate: false,
    },
  },
  methods: {
    generateReadableEvent(logEvent) {
      let convertedEvent = this.getReadableEvent(logEvent)

      if (convertedEvent == '') {
        return ''
      }

      const formattedTime = moment(logEvent.time.value).format('HH:mm:ss')

      let newEvent = `[${formattedTime}] ${convertedEvent}`

      return newEvent
    },
    getReadableEvent(logEvent) {
      let eventReadable = ''

      switch (logEvent.key) {
        case 'AREA_OPENED':
          eventReadable = 'Entre dans la zone : ' + logEvent.value
          break
        case 'AREA_CLOSED':
          eventReadable = 'Sors de la zone : ' + logEvent.value
          break
        case 'PRODUCT_SELECTED':
          eventReadable = 'Sélectionne le produit : ' + logEvent.value
          break
        case 'BEACON_SELECTED':
          eventReadable = 'Valide le beacon : ' + logEvent.value + ' - ' + logEvent.rawName
          break
        case 'LOCATION_SELECTED':
          eventReadable = 'Valide le position : ' + logEvent.value
          break
        case 'LANGUAGE_SELECTED':
          eventReadable = 'Sélectionne la langue : ' + logEvent.value
          break
        case 'SESSION_STARTED':
          eventReadable = 'Démarre la session : ' + logEvent.value
          break
        case 'SESSION_ENDED':
          eventReadable = 'Termine la session : ' + logEvent.value
          break
        case 'HISTOMATON':
          eventReadable = 'Prend un Histomaton : ' + logEvent.value
          break
        case 'EMAIL':
          eventReadable = "Entre l'adresse mail : " + logEvent.value
          break
        case 'COMMENT':
          eventReadable = 'Ajoute un commentaire : ' + logEvent.value
          break
        case 'RATING_HISTOPAD':
          eventReadable = "Note l'Histopad : " + logEvent.value
          break
        case 'RATING_VISIT':
          eventReadable = 'Note le lieu : ' + logEvent.value
          break
        case 'REWARD':
          eventReadable = 'Obtient la récompense : ' + logEvent.value
          break
        case 'SCENE_OPENED':
          eventReadable = 'Ouvre la scène : ' + logEvent.value
          break
        case 'SCENE_CLOSED':
          eventReadable =
            'Ferme la scène : ' + logEvent.value + '\n -----------------------------------'
          break
        case 'LOADING_TIME':
          eventReadable = 'Chargement terminé : ' + logEvent.value
          break
        case 'MAPFLOOR_CHANGED':
          eventReadable = "Changement d'étage : " + logEvent.rawName
          break
        case 'INFOPANEL_OPENED':
          eventReadable = "Ouvre l'aide : " + logEvent.value
          break
        case 'INFOPANEL_CLOSED':
          eventReadable = "Ferme l'aide : " + logEvent.value
          break
        case 'MAPCARTEL_OPENED':
          eventReadable = "Ouvre le cartel de l'itinéraire : " + logEvent.value
          break
        case 'MAPCARTEL_CLOSED':
          eventReadable = "Ferme le cartel de l'itinéraire : " + logEvent.value
          break
        case 'BUTTON_TRIGGERED':
          eventReadable = 'Clique sur le bouton : ' + logEvent.value
          break
        case 'BUTTON_DRAGGED':
          eventReadable = 'Drag sur le bouton : ' + logEvent.value
          break
        case 'CARTEL_OPENED':
          eventReadable = 'Ouvre le cartel : ' + logEvent.value
          break
        case 'CARTEL_CLOSED':
          eventReadable = 'Ferme le cartel : ' + logEvent.value
          break
        case 'HOTSPOT_CLICKED':
          eventReadable =
            'Clique sur le hotspot : ' + logEvent.value + ' de type : ' + logEvent.type
          break
        case 'TEXT_OPENED':
          eventReadable = 'Ouvre le texte : ' + logEvent.value
          break
        case 'TEXT_CLOSED':
          eventReadable = 'Ferme le texte : ' + logEvent.value
          break
        case 'CLOSEUP_OPENED':
          eventReadable = 'Ouvre le Close up : ' + logEvent.value
          break
        case 'CLOSEUP_CLOSED':
          eventReadable = 'Ferme le Close up : ' + logEvent.value
          break
        case 'ANIMATION_PLAYED':
          eventReadable = "Joue l'animation : " + logEvent.value
          break
        case 'RELIC_COLLECTED':
          eventReadable = 'Collecte la relique : ' + logEvent.value
          break
        case '3DMODEL_OPENED':
          eventReadable = 'Ouvre le modèle 3D : ' + logEvent.value
          break
        case '3DMODEL_CLOSED':
          eventReadable = 'Ferme le modèle 3D : ' + logEvent.value
          break
        case 'CINEMA_OPENED':
          eventReadable = 'Active le mode Cinéma : ' + logEvent.value
          break
        case 'CINEMA_CLOSED':
          eventReadable = 'Désactive le mode Cinéma : ' + logEvent.value
          break
        case 'MENU_OPENED':
          eventReadable = 'Ouvre le menu : ' + logEvent.value
          break
        case 'MENU_CLOSED':
          eventReadable = 'Ferme le menu : ' + logEvent.value
          break
        case 'ZOOMUI_SHOW':
          eventReadable = 'Ouvre le widget de zoom : ' + logEvent.value
          break
        case 'ZOOMUI_HIDE':
          eventReadable = 'Ferme le widget de zoom : ' + logEvent.value
          break
        case 'ZOOM_CHANGED':
          eventReadable = 'Change le Zoom : ' + logEvent.value
          break
        case 'VOLUMEUI_SHOW':
          eventReadable = 'Ouvre le widget de volume : ' + logEvent.value
          break
        case 'VOLUMEUI_HIDE':
          eventReadable = 'Ferme le widget de volume : ' + logEvent.value
          break
        case 'VOLUME_CHANGED':
          eventReadable = 'Change le volume : ' + logEvent.value
          break
        case 'INACTIVITY_STARTED':
          eventReadable = "Début d'inactivité : " + logEvent.value
          break
        case 'INACTIVITY_ENDED':
          eventReadable = "Fin d'inactivité : " + logEvent.value
          break
        case 'TOILETSPATH_ENABLED':
          eventReadable = "Active l'itinéraire des toilettes : " + logEvent.value
          break
        case 'ITINERARYSTEP_SELECTED':
          eventReadable = 'Sélectionne la destination : ' + logEvent.value
          break
        case 'ITINERARYSTEP_SKIPPED':
          eventReadable = 'Passe la destination : ' + logEvent.value
          break
        case 'APP_PAUSED':
          eventReadable = "Pause l'application : " + logEvent.value
          break
        case 'TUTORIAL_COMPLETED':
          eventReadable = 'Tutorial complèté : ' + logEvent.value
          break
        case 'TIMEGATE_ORIENTATION':
          eventReadable = 'Orientation de la PDT : ' + logEvent.value
          break
        case 'TIMEGATE_POSITION':
          eventReadable = 'Position de la PDT : ' + logEvent.value
          break
        case 'DEVICE_ORIENTATION':
          eventReadable = 'Orientation de la tablette : ' + logEvent.value
          break
        case 'PENDING_LOGS':
        case 'PENDING_IMAGES':
        case 'PENDING_DIAGNOSTICS':
        case 'BATTERY_LEVEL':
        case 'BATTERY_TEMPERATURE':
          break
        default:
          //this.$log.debug('unsupported key:', logEvent.key)
          break
      }

      return eventReadable
    },
    onEventMouseOver(logEvent) {
      this.$emit('overLogEvent', logEvent.time.value)
    },
    onEventMouseLeave() {
      this.$emit('outLogEvent')
    },
    logEventId(use) {
      const start = Math.round(
        moment
          .duration(moment(use.time.value).diff(moment(this.session.startTime.value)))
          .asSeconds(),
      )

      return 'event-' + start
    },
    scrollToLogEvent() {
      const elId = 'event-' + this.selectedLogEvent.start
      const el = document.getElementById(elId)
      const container = document.getElementById('logReader')
      container.scrollTop = el.offsetTop - container.offsetTop - 10
    },
  },
}
</script>

<style scoped>
.log-reader {
  max-height: 25rem;
  overflow: scroll;
  background-color: #20343d;
  padding: 1em;
}
</style>
